import React from 'react';

import { Modal, Tabs } from 'antd/lib';
import { graphql, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';

import getTraspasoPorId from '../../../graphql/querys/rrhh/getTraspasoPorId.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import TablaStock from '../../admGeneral/stock/TablaStock';
import DatosEntrega from './tabs/DatosEntrega';
import VerRecepcion from './tabs/VerRecepcion';

const TabPane = Tabs.TabPane;

@graphql(getUsuario)
class VisualizarTraspaso extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      filtro: '',
      traspaso: {},
    };

    this.props.client
      .query({
        query: getTraspasoPorId,
        variables: {
          _id: this.props.match.params.id,
        },
      })
      .then(res => {
        let traspaso = res.data.getTraspasoPorId;
        if (traspaso) {
          this.setState({
            ...this.state,
            loading: false,
            traspaso: traspaso,
          });
        }
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);

        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    if (this.state.traspaso && this.state.traspaso.estado != 'Confirmado') {
      this.props.history.push('/rrhh/traspasos');
    }

    return (
      <Tabs defaultActiveKey="entrega">
        <TabPane tab="Datos entrega" key="entrega">
          <DatosEntrega traspaso={this.state.traspaso} />
        </TabPane>
        <TabPane tab="Stock del traspaso" key="stock">
          <TablaStock tipo_sellos={this.state.traspaso.stock.detalle} />
        </TabPane>
        <TabPane tab="Datos recepcion" key="recepcion">
          <VerRecepcion traspaso={this.state.traspaso} />
        </TabPane>
      </Tabs>
    );
  }
}

export default withApollo(VisualizarTraspaso);
